import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DeliveryArticle } from '@knust/api-interfaces';

/**
 * Etiketten (105 x 55 mm) für die Einträge einer Wareneingangsbuchung. Die Komponente ist nur im Druck sichtbar
 * und wird über den DeliveryLabelsPrintService direkt unter <body> eingehängt (siehe Druckregeln in styles.scss).
 */
@Component({
  selector: 'knust-delivery-labels',
  templateUrl: './delivery-labels.component.html',
  styleUrls: ['./delivery-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeliveryLabelsComponent {
  articles = input.required<DeliveryArticle[]>();
}
